module.exports = __webpack_public_path__ + "static/bone_naga-4782ba589c04f59d06905740edf28926.jpg";